import React, { Component } from 'react';
import { EventStatsViewModel } from 'stageclip-common';
import { isEqual } from 'lodash';

import { EventsTableColumns } from '../../events/eventsTable';
import { MonitoringTableContainer } from '../table/MonitoringTableContainer';

import { PageTitle } from 'components/pages/pageTitle';
import styles from './Monitoring.module.scss';

const MonitoringPageTableColumns = [
  EventsTableColumns.ClientName,
  EventsTableColumns.EventName,
  EventsTableColumns.EventType,
  EventsTableColumns.EventStart,
  EventsTableColumns.Status,
  EventsTableColumns.TotalParticipants,
  EventsTableColumns.ParticipantsWithClipsGenerated,
  EventsTableColumns.TotalClipsProcessing,
  EventsTableColumns.TotalClipsPending,
  EventsTableColumns.ClipGenerationErrors,
  EventsTableColumns.TotalClipsWaitingForData,
  EventsTableColumns.ViewButton,
];

const initialState = {
  totalClipErrors: 0,
  totalClipsGenerated: 0,
  totalClipsPending: 0,
  totalClipsProcessing: 0,
  totalClipsWithoutData: 0,
  totalParticipants: 0,
};

type MonitoringVGState = {
  selectedTotals: Partial<EventStatsViewModel>;
  allTotals: Partial<EventStatsViewModel>;
  statsLoaded: boolean;
};

export class Monitoring extends Component<any, MonitoringVGState> {
  constructor(props: any) {
    super(props);

    this.state = {
      allTotals: { ...initialState },
      selectedTotals: { ...initialState },
      statsLoaded: false,
    };
  }

  handleStatisticsChange = (filteredRows: any[], allRows: any[]) => {
    if (!filteredRows || !allRows) {
      return;
    }
    const selectedTotals = this.computeTotalsFromRows(filteredRows);
    const allTotals = this.computeTotalsFromRows(allRows);

    this.setState(prevState => ({
      ...prevState,
      allTotals: isEqual(prevState.allTotals, initialState) ? allTotals : prevState.allTotals,
      selectedTotals,
    }));
  };

  computeTotalsFromRows(rows: any) {
    if (!rows.some((row: any) => row.totalParticipants === undefined)) {
      this.setState(prevState => ({
        ...prevState,
        statsLoaded: true,
      }));
    }

    return rows.reduce((result: EventStatsViewModel, row: any) => {
      return {
        totalClipErrors: result.totalClipErrors + (row.clipGenerationErrors || 0),
        totalClipsGenerated: result.totalClipsGenerated + (row.participantsWithClipsGenerated || 0),
        totalClipsPending: result.totalClipsPending + (row.totalClipsPending || 0),
        totalClipsProcessing: result.totalClipsProcessing + (row.totalClipsCurrentlyProcessing || 0),
        totalClipsWithoutData: result.totalClipsWithoutData + (row.totalParticipantsWaitingForData || 0),
        totalParticipants: result.totalParticipants + (row.totalParticipants || 0),
      };
    }, initialState);
  }

  renderStatistics(stats: Partial<EventStatsViewModel>, title: string) {
    const { statsLoaded } = this.state;
    const getEventStatistics = (data: string) => (statsLoaded ? stats[data] : '-');
    const values = [
      { label: 'Total participants', key: 'totalParticipants' },
      { label: 'Total clip generation errors', key: 'totalClipErrors' },
      { label: 'Total clips generated', key: 'totalClipsGenerated' },
      { label: 'Total clips currently processing', key: 'totalClipsProcessing' },
      { label: 'Total clips waiting to be generated', key: 'totalClipsPending' },
      { label: 'Total participants waiting for clipping data', key: 'totalClipsWithoutData' },
    ];

    return (
      <div className={styles.statsTotals}>
        <div className={styles.title}>{title}</div>
        {values.map(statistic => (
          <div key={statistic.key}>
            <span className={styles.label}>{statistic.label}</span>
            <span className={styles.value}>{getEventStatistics(statistic.key)}</span>
          </div>
        ))}
      </div>
    );
  }

  render() {
    const { fetchStatistics, fetchEvents } = this.props;
    const { selectedTotals, allTotals } = this.state;

    return (
      <>
        <PageTitle displayTitle="Events Statistics" />
        <>
          <div>
            {this.renderStatistics(selectedTotals, 'Statistics for selected events')}
            {this.renderStatistics(allTotals, 'All time statistics')}
          </div>
          <MonitoringTableContainer
            columns={MonitoringPageTableColumns}
            onFilterChange={this.handleStatisticsChange}
            getStatistics={fetchStatistics}
            fetchEvents={fetchEvents}
          />
        </>
      </>
    );
  }
}
